import src from "IMAGE";
export default { src, width: 208, height: 48, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAMElEQVR42i3HoQ0AIAxFwb8QsA/BAQYIot0/6RMVJ06SPhyGgZYKKrTwcHDRMfM7AKwbBZqxV7aBAAAAAElFTkSuQmCC"};
